import { Field, FieldMapValue, FieldTypes, isAlphaNumeric } from '@hb/shared'
import { useMemo } from 'react'
import { useCollection } from '../backend/db/hooks/useCollection'
import { useCollections } from '../store/collections'
import { formatValue } from '../utils/data'

export const useFormattedValue = (
  field?: Field,
  value?: any,
  parentValue?: FieldMapValue,
  textOnly?: boolean,
) => {
  const collections = useCollections()

  const collection = useMemo(() => {
    if (!field) return null
    switch (field.type) {
      case FieldTypes.ID:
      case FieldTypes.DYNAMIC_DROPDOWN:
        return field.collection
      default:
        return null
    }
  }, [field])

  const itemId = useMemo(() => {
    if (typeof value !== 'string') return null
    return isAlphaNumeric(value) ? value : null
  }, [value])

  const collectionData = useCollection(collection)

  const formatted = useMemo(
    () =>
      formatValue({
        field,
        value,
        parentValue,
        collections,
        textOnly,
      }),
    [field, value, collections, textOnly, parentValue],
  )

  return useMemo(
    () => ({
      collection: collectionData,
      itemId,
      value: formatted,
    }),
    [itemId, formatted, collectionData],
  )
}
